import React from "react";

import { classNames } from "components/utils";

const TeamTable = React.forwardRef<
  HTMLTableElement,
  React.TableHTMLAttributes<HTMLTableElement>
>(({ className, ...props }, forwardedRef) => (
  <div className="overflow-x-auto pb-7 shadow-sm ring-1 ring-black ring-opacity-5">
    <table
      ref={forwardedRef}
      className={classNames(
        "min-w-full border border-gray-300 dark:border-neutral-800",
        className || "",
      )}
      {...props}
    />
  </div>
));

TeamTable.displayName = "TeamTable";

const TeamTableHead = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, forwardedRef) => (
  <thead
    ref={forwardedRef}
    className={classNames("bg-gray-50", className || "")}
    {...props}
  />
));

TeamTableHead.displayName = "TeamTableHead";

const TeamTableHeaderCell = React.forwardRef<
  HTMLTableCellElement,
  React.ThHTMLAttributes<HTMLTableCellElement>
>(({ className, children, scope = "col", ...props }, forwardedRef) => (
  <th
    ref={forwardedRef}
    scope={scope}
    className={classNames(
      "border-b border-gray-300 bg-gray-50 bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-700 dark:border-neutral-800 dark:bg-neutral-800 dark:text-secondary",
      className || "",
    )}
    {...props}
  >
    <div className="group inline-flex">{children}</div>
  </th>
));

TeamTableHeaderCell.displayName = "TeamTableHeaderCell";

const TeamTableBody = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, forwardedRef) => (
  <tbody
    ref={forwardedRef}
    className={classNames("bg-white dark:bg-neutral-900", className || "")}
    {...props}
  />
));

TeamTableBody.displayName = "TeamTableBody";

interface TeamTableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
  isLastRow?: boolean;
}

const TeamTableCell = React.forwardRef<
  HTMLTableCellElement,
  TeamTableCellProps
>(({ className, isLastRow = false, ...props }, forwardedRef) => (
  <td
    ref={forwardedRef}
    className={classNames(
      !isLastRow ? "border-b border-gray-200 dark:border-neutral-800" : "",
      "whitespace-nowrap px-3 py-4 text-sm text-gray-500 dark:text-secondary",
      className || "",
    )}
    {...props}
  />
));

TeamTableCell.displayName = "TeamTableCell";

export {
  TeamTable,
  TeamTableBody,
  TeamTableCell,
  TeamTableHead,
  TeamTableHeaderCell,
};
